/* XC Glow — small, dependency-free theme script (loaded with defer). */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const T = window.theme || { routes: {}, strings: {} };

  /* ---------- Drawers (menu, cart) ---------- */
  let lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-open'));
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const f = el.querySelector('[data-autofocus], button, a, input');
    if (f) setTimeout(() => f.focus(), 60);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const d = document.getElementById(opener.dataset.drawerOpen);
      if (d) { e.preventDefault(); openDrawer(d); }
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer, .search-modal')); return; }
    // close open nav dropdowns when clicking elsewhere
    $$('.nav details[open], .facet[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open, .search-modal.is-open').forEach(closeDrawer);
    $$('.nav details[open], .facet[open]').forEach((d) => d.removeAttribute('open'));
  });

  /* ---------- Search + predictive results ---------- */
  const modal = $('#SearchModal');
  if (modal) {
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); lastFocus = document.activeElement; modal.classList.add('is-open'); $('input[type=search]', modal).focus(); }
      else if (e.target === modal) closeDrawer(modal);
    });
    const input = $('input[type=search]', modal);
    const out = $('[data-predictive]', modal);
    let timer, ctrl;
    if (input && out) input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `${T.routes.search}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[limit]=6&section_id=predictive-search`;
          const html = await (await fetch(url, { signal: ctrl.signal })).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const res = doc.querySelector('[data-predictive-results]');
          out.innerHTML = res ? res.innerHTML : '';
        } catch (err) { /* aborted */ }
      }, 220);
    });
  }

  /* ---------- Cart (drawer + page) ---------- */
  const cartSections = () => {
    const ids = ['cart-icon-bubble'];
    if ($('#CartDrawer')) ids.push('cart-drawer');
    const page = $('[data-cart-page]');
    if (page) ids.push(page.dataset.section);
    return ids;
  };
  function renderSections(sections) {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      $$(`[data-render="${id}"]`).forEach((target) => {
        const key = target.dataset.renderKey;
        const fresh = doc.querySelector(key ? `[data-render="${id}"][data-render-key="${key}"]` : `[data-render="${id}"]`);
        if (fresh) target.innerHTML = fresh.innerHTML;
      });
    });
  }
  async function cartRequest(url, body) {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
    return data;
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-cart-form]');
    if (!form || T.cartType !== 'drawer' || !$('#CartDrawer')) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const err = form.querySelector('[data-form-error]');
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    if (err) err.hidden = true;
    try {
      const fd = new FormData(form);
      const body = { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }], sections: cartSections(), sections_url: window.location.pathname };
      const sp = fd.get('selling_plan'); if (sp) body.items[0].selling_plan = sp;
      fd.forEach((v, k) => { const m = k.match(/^properties\[(.+)\]$/); if (m) { body.items[0].properties = body.items[0].properties || {}; body.items[0].properties[m[1]] = v; } });
      const data = await cartRequest(T.routes.cartAdd + '.js', body);
      renderSections(data.sections);
      openDrawer($('#CartDrawer'));
    } catch (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; } else alert(ex.message);
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
    }
  });

  async function changeLine(line, quantity, root) {
    const box = root.closest('[data-cart-root]') || root;
    box.classList.add('is-updating');
    try {
      const data = await cartRequest(T.routes.cartChange + '.js', { line, quantity, sections: cartSections(), sections_url: window.location.pathname });
      renderSections(data.sections);
    } catch (ex) { alert(ex.message); }
    finally { $$('.is-updating').forEach((n) => n.classList.remove('is-updating')); }
  }
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); changeLine(Number(rm.dataset.cartRemove), 0, rm); }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.closest('.qty').querySelector('input');
    const min = Number(input.min || 0);
    const next = Math.max(min, Number(input.value || 0) + Number(b.dataset.qtyStep));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty]');
    if (input) changeLine(Number(input.dataset.cartQty), Number(input.value), input);
  });

  /* ---------- Variant picker ---------- */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.addEventListener('change', () => this.update());
    }
    update() {
      const selected = $$('fieldset', this).map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
      const v = this.variants.find((x) => x.options.every((o, i) => o === selected[i]));
      const sectionId = this.dataset.section;
      const root = document.getElementById(`product-${sectionId}`);
      $$(`[data-variant-input="${sectionId}"]`).forEach((i) => { i.value = v ? v.id : ''; });
      $$(`[data-buy="${sectionId}"]`).forEach((b) => { b.disabled = !v || !v.available; if (!v) b.querySelector('.btn__label').textContent = T.strings.unavailable; });
      if (!v) return;
      if (this.dataset.updateUrl !== 'false') history.replaceState({}, '', `${this.dataset.url}?variant=${v.id}`);
      if (v.featured_media && root) {
        const slide = root.querySelector(`[data-media-id="${v.featured_media.id}"]`);
        if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      fetch(`${this.dataset.url}?variant=${v.id}&section_id=${this.dataset.sectionTemplate || sectionId}`)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const scope = root ? root.closest('.section') || root : document;
          $$('[data-swap]', scope).forEach((n) => {
            const fresh = doc.querySelector(`[data-swap="${n.dataset.swap}"]`);
            if (fresh) n.innerHTML = fresh.innerHTML;
          });
        });
    }
  }
  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker);

  /* ---------- Gallery (scroll-snap slider with thumbs/dots) ---------- */
  $$('[data-gallery]').forEach((g) => {
    const track = $('.gallery__main', g);
    const thumbs = $$('.gallery__thumb', g);
    const dots = $$('.gallery__dots span', g);
    thumbs.forEach((t, i) => t.addEventListener('click', () => { const s = track.children[i]; track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); }));
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      const i = Array.prototype.indexOf.call(track.children, en.target);
      thumbs.forEach((t, j) => t.setAttribute('aria-current', i === j));
      dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
      $$('video', track).forEach((v) => { if (!en.target.contains(v)) v.pause(); });
    }), { root: track, threshold: 0.6 });
    Array.from(track.children).forEach((c) => io.observe(c));
  });

  /* ---------- Product recommendations (lazy) ---------- */
  $$('[data-recs]').forEach((el) => {
    const load = async () => {
      try {
        const html = await (await fetch(el.dataset.recs)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recs]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; $$('.reveal', el).forEach((n) => n.classList.add('is-in')); }
      } catch (x) {}
    };
    new IntersectionObserver((en, o) => { if (en[0].isIntersecting) { o.disconnect(); load(); } }, { rootMargin: '400px 0px' }).observe(el);
  });

  /* ---------- Sticky add to cart (mobile) ---------- */
  const sticky = $('[data-sticky-atc]');
  const mainBuy = sticky && document.getElementById(sticky.dataset.target);
  if (sticky && mainBuy) {
    new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(mainBuy);
    sticky.querySelector('button').addEventListener('click', () => {
      const form = mainBuy.closest('form') || document.getElementById(sticky.dataset.form);
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  /* ---------- Announcement rotation ---------- */
  $$('[data-rotate]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    let i = 0;
    const speed = Number(bar.dataset.rotate) * 1000 || 5000;
    let paused = false;
    bar.addEventListener('mouseenter', () => { paused = true; });
    bar.addEventListener('mouseleave', () => { paused = false; });
    setInterval(() => {
      if (paused) return;
      items[i].classList.remove('is-active'); items[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active'); items[i].removeAttribute('aria-hidden');
    }, speed);
  });

  /* ---------- Collection filters: submit on change ---------- */
  $$('form[data-facets]').forEach((form) => {
    let t;
    form.addEventListener('change', (e) => {
      clearTimeout(t);
      t = setTimeout(() => {
        const params = new URLSearchParams(new FormData(form));
        for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
        window.location.search = params.toString();
      }, e.target.type === 'number' ? 700 : 0);
    });
  });

  /* ---------- Share ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-share]');
    if (!b) return;
    const url = b.dataset.share;
    if (navigator.share) { try { await navigator.share({ title: document.title, url }); } catch (x) {} }
    else if (navigator.clipboard) { await navigator.clipboard.writeText(url); const l = b.querySelector('span'); if (l) { const o = l.textContent; l.textContent = b.dataset.copied; setTimeout(() => { l.textContent = o; }, 2000); } }
  });

  /* ---------- Reveal on scroll ---------- */
  if (document.body.classList.contains('has-anim') && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', (e) => { $$('.reveal', e.target).forEach((el) => el.classList.add('is-in')); });
  document.addEventListener('shopify:block:select', (e) => { const el = e.target; if (el.scrollIntoView && el.closest('.slider-m, .tiles')) el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }); });
})();
